import {notification} from 'antd';

export const NOTIFICATION_DURATION_SECONDS = 6;
const NOTIFICATION_PLACEMENT = 'topRight';

let isConfigured = false;
const autoCloseTimers = new Map<string, number>();

const configureNotification = (): void => {
  if (isConfigured) {
    return;
  }

  notification.config({
    placement: NOTIFICATION_PLACEMENT,
    duration: NOTIFICATION_DURATION_SECONDS
  });

  isConfigured = true;
};

const scheduleAutoClose = (key: string): void => {
  const existing = autoCloseTimers.get(key);

  if (existing != null) {
    window.clearTimeout(existing);
  }

  const timer = window.setTimeout(() => {
    notification.destroy(key);
    autoCloseTimers.delete(key);
  }, NOTIFICATION_DURATION_SECONDS * 1000);

  autoCloseTimers.set(key, timer);
};

export type AlertNotificationType = 'warning' | 'error' | 'success';

export interface ShowAlertNotificationParams {
  type: AlertNotificationType;
  message: string;
  description?: string;
  key?: string;
}

export const dismissAlertNotification = (key: string): void => {
  const existing = autoCloseTimers.get(key);

  if (existing != null) {
    window.clearTimeout(existing);
    autoCloseTimers.delete(key);
  }

  notification.destroy(key);
};

const showAlertNotification = ({
  type,
  message,
  description,
  key
}: ShowAlertNotificationParams): void => {
  configureNotification();

  const noticeKey = key ?? `bc-alert-${type}-${Date.now()}`;

  notification[type]({
    message,
    description,
    key: noticeKey,
    duration: NOTIFICATION_DURATION_SECONDS,
    placement: NOTIFICATION_PLACEMENT,
    className: `bc-alert-notification bc-alert-notification--${type}`
  });

  scheduleAutoClose(noticeKey);
};

export default showAlertNotification;
